import { PRESUPUESTADOR_SET_TEST_DRIVE } from './constants'

export function setTestDrive(data) {
  return { type: PRESUPUESTADOR_SET_TEST_DRIVE, data }
}

export function reducer(state, action) {
  if (action.type === PRESUPUESTADOR_SET_TEST_DRIVE) {
      return { ...state, test_drive: action.data }
  }
  else {
      return state
  }
}
